"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _reactRouterDom = require("react-router-dom");

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["disabled", "disabledSuccess", "fixedWidth", "children", "to", "onClick", "size", "type", "isLightButton", "isLoading", "isUppercase", "isSmall", "isSuccess", "isDanger", "isDefault", "isAccent"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLightGrey;
}, function (p) {
  return p.theme.colorText;
});
var whitePrimaryStyles = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorAccent;
}, function (p) {
  return p.theme.colorAccentText;
});
var accentStyles = (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorAccent;
}, function (p) {
  return p.theme.colorAccentText;
});
var successStyles = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n\n  & .spinner {\n    border-color: ", ";\n    border-top-color: ", ";\n  }\n"])), function (p) {
  return p.theme.colorSuccess;
}, function (p) {
  return p.theme.colorSuccessText || "white";
}, function (p) {
  return (0, _polished.rgba)(p.theme.colorSuccessText, 0.1);
}, function (p) {
  return p.theme.colorSuccessText;
});
var dangerStyles = (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.colorDanger;
}, function (p) {
  return p.theme.colorDangerText || "white";
});
var sharedStyles = (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: ", ";\n  line-height: 1;\n  ", ";\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  white-space: nowrap;\n  background: ", ";\n  color: ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  transition: background 0.25s;\n\n  &::first-letter {\n    text-transform: uppercase;\n  }\n"])), function (p) {
  return p.fixedWidth || "100%";
}, function (p) {
  return p.isUppercase || p.theme.buttonUppercase ? "text-transform: uppercase" : "";
}, function (p) {
  return p.theme.inputBorderRadius;
}, function (p) {
  return p.theme.colorPrimary;
}, function (p) {
  return p.theme.colorPrimaryText;
}, function (p) {
  var _p$theme, _p$theme$colorPrimary;

  return ((_p$theme = p.theme) === null || _p$theme === void 0 ? void 0 : (_p$theme$colorPrimary = _p$theme.colorPrimary) === null || _p$theme$colorPrimary === void 0 ? void 0 : _p$theme$colorPrimary.includes("#fff")) && whitePrimaryStyles;
}, function (p) {
  return p.isSuccess && successStyles;
}, function (p) {
  return p.isDanger && dangerStyles;
}, function (p) {
  return p.isDefault && defaultStyles;
}, function (p) {
  return p.isAccent && accentStyles;
});
var extraSmallButton = (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  height: 34px;\n  padding: 0 0.75rem;\n  font-size: 0.75rem;\n"])));
var smallButton = (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  height: 50px;\n  padding: 0 1rem;\n  font-size: 0.875rem;\n"])));
var mediumButton = (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  height: 60px;\n  padding: 0 1.5rem;\n  font-size: ", ";\n"])), function (p) {
  return p.theme.buttonFontSize || "1rem";
});
var disabledStyles = (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n  cursor: not-allowed;\n"])), function (p) {
  return p.theme.colorDisabledBackground;
}, function (p) {
  return p.theme.colorDisabledBackground;
}, function (p) {
  return p.theme.colorDisabledText;
});
var disabledSuccessStyles = (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  background: ", ";\n  border-color: ", ";\n  color: ", ";\n  opacity: 0.65;\n  cursor: not-allowed;\n"])), function (p) {
  return p.theme.colorAlertSuccessBackground;
}, function (p) {
  return p.theme.colorAlertSuccessBackground;
}, function (p) {
  return p.theme.colorAlertSuccessText;
});
var loadingStyles = (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  cursor: not-allowed;\n"])));

var StyledButton = _styledComponents.default.button(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n\n  ", ";\n  ", ";\n\n  &:disabled {\n    ", ";\n  }\n"])), sharedStyles, mediumButton, function (p) {
  return p.size === "sm" && smallButton;
}, function (p) {
  return p.size === "xs" && extraSmallButton;
}, function (p) {
  return p.isLoading ? loadingStyles : p.disabled && p.disabledSuccess ? disabledSuccessStyles : disabledStyles;
});

var sharedLinkStyles = (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n  ", ";\n  ", ";\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), sharedStyles, mediumButton, function (p) {
  return p.size === "sm" && smallButton;
}, function (p) {
  return p.size === "xs" && extraSmallButton;
});
var StyledLink = (0, _styledComponents.default)(_reactRouterDom.Link)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  ", ";\n"])), sharedLinkStyles);

var StyledDisabledLink = _styledComponents.default.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), sharedLinkStyles, disabledStyles);

var StyledSpinner = _styledComponents.default.span(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: inline-block;\n  border-width: ", "px;\n  border-style: solid;\n\n  ", "\n\n  border-color: ", ";\n  border-top-color: ", ";\n\n  flex: 0 0 ", "px;\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  animation: spin 1.25s infinite linear;\n\n  @keyframes spin {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"])), function (p) {
  return p.lineWidth;
}, ""
/* border-color: ${(p) =>
p.forDark ? rgba("white", 0.275) : rgba("black", 0.1)}; */
, function (p) {
  return (0, _polished.rgba)(p.theme.colorPrimaryText, 0.2);
}, function (p) {
  return p.theme.colorPrimaryText;
}, function (p) {
  return Math.floor(p.lineWidth * 7);
}, function (p) {
  return Math.floor(p.lineWidth * 7);
}, function (p) {
  return Math.floor(p.lineWidth * 7);
});

var StyledDisabledSuccessIcon = (0, _styledComponents.default)(_.MatIcon)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 1rem;\n  transform: translate(0, -50%);\n"])));

var BlockButton = function BlockButton(_ref) {
  var disabled = _ref.disabled,
      disabledSuccess = _ref.disabledSuccess,
      fixedWidth = _ref.fixedWidth,
      children = _ref.children,
      to = _ref.to,
      onClick = _ref.onClick,
      size = _ref.size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "button" : _ref$type,
      isLightButton = _ref.isLightButton,
      isLoading = _ref.isLoading,
      isUppercase = _ref.isUppercase,
      isSmall = _ref.isSmall,
      isSuccess = _ref.isSuccess,
      isDanger = _ref.isDanger,
      isDefault = _ref.isDefault,
      isAccent = _ref.isAccent,
      rest = _objectWithoutProperties(_ref, _excluded);

  return to ? disabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDisabledLink, _objectSpread(_objectSpread({}, rest), {}, {
    size: size,
    isUppercase: isUppercase,
    fixedWidth: fixedWidth,
    children: children
  })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLink, _objectSpread(_objectSpread({
    isUppercase: isUppercase,
    fixedWidth: fixedWidth,
    to: to,
    size: size,
    isSuccess: isSuccess,
    isDanger: isDanger,
    isDefault: isDefault,
    isAccent: isAccent
  }, rest), {}, {
    children: children
  })) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, _objectSpread(_objectSpread({
    type: type,
    isUppercase: isUppercase,
    fixedWidth: fixedWidth,
    onClick: onClick,
    size: size,
    disabled: disabled,
    disabledSuccess: disabledSuccess,
    isLoading: isLoading,
    isSuccess: isSuccess,
    isDanger: isDanger,
    isDefault: isDefault,
    isAccent: isAccent
  }, rest), {}, {
    children: [disabled && disabledSuccess && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDisabledSuccessIcon, {
      children: "verified_user"
    }), !isLoading ? children : /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpinner, {
      className: "spinner",
      forDark: !isLightButton,
      lineWidth: size === "sm" ? 4 : 5
    })]
  }));
};

var _default = BlockButton;
exports.default = _default;